import { render, staticRenderFns } from "./ProfessionalInsurances.vue?vue&type=template&id=2ef30b4d"
import script from "./ProfessionalInsurances.vue?vue&type=script&lang=js"
export * from "./ProfessionalInsurances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports